import { AppDrawerContent } from '../../../../../components-v2/Drawer/AppDrawer';
import { ContactInfo } from './ContactInfo';

type Props = {
	contactId: string | null | undefined;
};

export const ContactInfoAppDrawerContent = ({ contactId }: Props) => {
	return (
		<AppDrawerContent value='contact-info'>
			{/* Remount contact-scoped edit state when switching contacts. */}
			<ContactInfo key={contactId} contactId={contactId} />
		</AppDrawerContent>
	);
};
